import { setTransactionsLiability } from "@actions/transactions";
import { connect } from "react-redux";
import BaseTab from "./BaseTab";

class LiabilityTab extends BaseTab {
  fnDispatch = this.props.setTransactionsLiability;
}

const mapStateToProps = (state) => {
  return {
    data: state.transactionsLiability,
    view: state.transactionsView,
    filters: state.transactionsFilters,
  };
};

export default connect(mapStateToProps, { setTransactionsLiability })(
  LiabilityTab,
);
